import KdbImg from "../assets/images/bank-card-images/kdb.png";
import GieobImg from "../assets/images/bank-card-images/gieob.png";
import KbImg from "../assets/images/bank-card-images/kb-bank.png";
import SuhyeobImg from "../assets/images/bank-card-images/suhyeob.png";
import NhImg from "../assets/images/bank-card-images/nh.png";
import WooriImg from "../assets/images/bank-card-images/woori.png";
import ScBankiImg from "../assets/images/bank-card-images/sc-bank.png";
import CitiImg from "../assets/images/bank-card-images/citi.png";
import DaeguImg from "../assets/images/bank-card-images/dae-gu.png";
import BusanImg from "../assets/images/bank-card-images/busan.png";
import JeonbukImg from "../assets/images/bank-card-images/jeonbuk.png";
import ShinhanImg from "../assets/images/bank-card-images/shinhan.png";
import SaemaulGeumgoImg from "../assets/images/bank-card-images/saemaul-geumgo.png";
import SinhyeobImg from "../assets/images/bank-card-images/sinhyeob.png";
import SanlimImg from "../assets/images/bank-card-images/sanlim.png";
import PostOfficeImg from "../assets/images/bank-card-images/post-office.png";
import HanaBankImg from "../assets/images/bank-card-images/hana-bank.png";
import KBankImg from "../assets/images/bank-card-images/k-bank.png";
import KakaoImg from "../assets/images/bank-card-images/kakao.png";

export const BANK_DATA = [
  {
    pbkCode: "002",
    cbkCode: "002",
    fcode: "002",
    name: "산업은행",
    bankImg: KdbImg,
  },
  {
    pbkCode: "003",
    cbkCode: "003",
    fcode: "003",
    name: "기업은행",
    bankImg: GieobImg,
  },
  {
    pbkCode: "004",
    cbkCode: "004",
    fcode: "004",
    name: "국민은행",
    bankImg: KbImg,
  },
  {
    pbkCode: "007",
    cbkCode: "007",
    fcode: "007",
    name: "수협은행",
    bankImg: SuhyeobImg,
  },
  {
    pbkCode: "011",
    cbkCode: "011",
    fcode: "011",
    name: "농협은행",
    bankImg: NhImg,
  },
  {
    pbkCode: "020",
    cbkCode: "020",
    fcode: "020",
    name: "우리은행",
    bankImg: WooriImg,
  },
  {
    pbkCode: "023",
    cbkCode: "023",
    fcode: "023",
    name: "SC은행",
    bankImg: ScBankiImg,
  },
  {
    pbkCode: "027",
    cbkCode: "027",
    fcode: "027",
    name: "씨티은행",
    bankImg: CitiImg,
  },
  {
    pbkCode: "031",
    cbkCode: "031",
    fcode: "031",
    name: "대구은행",
    bankImg: DaeguImg,
  },
  {
    pbkCode: "032",
    cbkCode: "032",
    fcode: "032",
    name: "부산은행",
    bankImg: BusanImg,
  },
  {
    pbkCode: "034",
    cbkCode: "034",
    fcode: "034",
    name: "광주은행",
    bankImg: JeonbukImg,
  },
  {
    pbkCode: "035",
    cbkCode: "035",
    fcode: "035",
    name: "제주은행",
    bankImg: ShinhanImg,
  },
  {
    pbkCode: "037",
    cbkCode: "037",
    fcode: "037",
    name: "전북은행",
    bankImg: JeonbukImg,
  },
  {
    pbkCode: "039",
    cbkCode: "039",
    fcode: "039",
    name: "경남은행",
    bankImg: BusanImg,
  },
  {
    pbkCode: "045",
    cbkCode: "045",
    fcode: "045",
    name: "새마을금고",
    bankImg: SaemaulGeumgoImg,
  },
  {
    pbkCode: "048",
    cbkCode: "048",
    fcode: "048",
    name: "신협",
    bankImg: SinhyeobImg,
  },
  {
    pbkCode: "064",
    cbkCode: "",
    fcode: "064",
    name: "산림조합중앙회",
    bankImg: SanlimImg,
  },
  {
    pbkCode: "071",
    cbkCode: "079",
    fcode: "079",
    name: "우체국",
    bankImg: PostOfficeImg,
  },
  {
    pbkCode: "081",
    cbkCode: "081",
    fcode: "081",
    name: "하나은행",
    bankImg: HanaBankImg,
  },
  {
    pbkCode: "088",
    cbkCode: "088",
    fcode: "088",
    name: "신한은행",
    bankImg: ShinhanImg,
  },
  {
    pbkCode: "089",
    cbkCode: "089",
    fcode: "089",
    name: "K뱅크",
    bankImg: KBankImg,
  },
  {
    pbkCode: "",
    cbkCode: "090",
    fcode: "090",
    name: "카카오뱅크",
    bankImg: KakaoImg,
  },
];

export const BANK_TYPE = [
  { label: "법인", value: "cbk" },
  { label: "개인", value: "pbk" },
];

export const BANK_CODE = [
  { code: "001", value: "한국은행" },
  { code: "002", value: "산업은행" },
  { code: "003", value: "기업은행" },
  { code: "004", value: "국민은행" },
  { code: "007", value: "수협은행" },
  { code: "008", value: "수출입은행" },
  { code: "011", value: "NH농협은행" },
  { code: "012", value: "지역농․축협" },
  { code: "020", value: "우리은행" },
  { code: "023", value: "SC제일은행" },
  { code: "027", value: "한국씨티은행" },
  { code: "031", value: "대구은행" },
  { code: "032", value: "부산은행" },
  { code: "034", value: "광주은행" },
  { code: "035", value: "제주은행" },
  { code: "037", value: "전북은행" },
  { code: "039", value: "경남은행" },
  { code: "041", value: "우리카드" },
  { code: "045", value: "새마을금고" },
  { code: "048", value: "신협" },
  { code: "050", value: "저축은행" },
  { code: "052", value: "모건스탠리은행" },
  { code: "054", value: "HSBC은행" },
  { code: "055", value: "도이치은행" },
  { code: "057", value: "제이피모간체이스은행" },
  { code: "058", value: "미즈호은행" },
  { code: "059", value: "엠유에프지은행" },
  { code: "060", value: "BOA은행" },
  { code: "061", value: "비엔피파리바은행" },
  { code: "062", value: "중국공상은행" },
  { code: "063", value: "중국은행" },
  { code: "064", value: "산림조합중앙회" },
  { code: "065", value: "대화은행" },
  { code: "066", value: "교통은행" },
  { code: "067", value: "중국건설은행" },
  { code: "071", value: "우체국" },
  { code: "076", value: "신용보증기금" },
  { code: "077", value: "기술보증기금" },
  { code: "081", value: "하나은행" },
  { code: "088", value: "신한은행" },
  { code: "089", value: "케이뱅크" },
  { code: "090", value: "카카오뱅크" },
  { code: "092", value: "토스뱅크" },
  { code: "101", value: "한국신용정보원" },
  { code: "102", value: "대신저축은행" },
  { code: "103", value: "에스비아이저축은행" },
  { code: "104", value: "에이치케이저축은행" },
  { code: "105", value: "웰컴저축은행" },
  { code: "106", value: "신한저축은행" },
  { code: "209", value: "유안타증권" },
  { code: "218", value: "KB증권" },
  { code: "221", value: "상상인증권" },
  { code: "222", value: "한양증권" },
  { code: "223", value: "리딩투자증권" },
  { code: "224", value: "BNK투자증권" },
  { code: "225", value: "IBK투자증권" },
  { code: "227", value: "KTB투자증권" },
  { code: "238", value: "미래에셋증권" },
  { code: "240", value: "삼성증권" },
  { code: "243", value: "한국투자증권" },
  { code: "247", value: "NH투자증권" },
  { code: "261", value: "교보증권" },
  { code: "262", value: "하이투자증권" },
  { code: "263", value: "현대차증권" },
  { code: "264", value: "키움증권" },
  { code: "265", value: "이베스트투자증권" },
  { code: "266", value: "SK증권" },
  { code: "267", value: "대신증권" },
  { code: "269", value: "한화투자증권" },
  { code: "270", value: "하나금융투자" },
  { code: "271", value: "토스증권" },
  { code: "272", value: "NH선물" },
  { code: "278", value: "신한금융투자" },
  { code: "279", value: "DB금융투자" },
  { code: "280", value: "유진투자증권" },
  { code: "287", value: "메리츠증권" },
  { code: "288", value: "카카오페이증권" },
  { code: "290", value: "부국증권" },
  { code: "291", value: "신영증권" },
  { code: "292", value: "케이프투자증권" },
]